import script from "./UpdateStatusDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateStatusDialog.vue?vue&type=script&setup=true&lang=js"

import "./UpdateStatusDialog.vue?vue&type=style&index=0&id=ab8fc79e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/employer/employer/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab8fc79e"]])

export default __exports__